
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 24h-14A1.5 1.5 0 011 22.5v-16A1.5 1.5 0 012.5 5h14A1.5 1.5 0 0118 6.5v16a1.5 1.5 0 01-1.5 1.5zM2.5 6a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-16a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M21.5 19h-2a.5.5 0 010-1h2a.5.5 0 00.5-.5v-16a.5.5 0 00-.5-.5h-14a.5.5 0 00-.5.5v2a.5.5 0 11-1 0v-2A1.5 1.5 0 017.5 0h14A1.5 1.5 0 0123 1.5v16a1.5 1.5 0 01-1.5 1.5z"}}),_c('path',{attrs:{"d":"M16.5 24h-14A1.5 1.5 0 011 22.5v-16A1.5 1.5 0 012.5 5h14A1.5 1.5 0 0118 6.5v16a1.5 1.5 0 01-1.5 1.5zM2.5 6a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-16a.5.5 0 00-.5-.5z"}})])
          )
        }
      }
    